import React, { useState } from "react";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { ArrowDropDown, ArrowRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { useParams } from "react-router-dom";
const RecceDropdown = () => {
    const navigate = useNavigate(); // Initialize navigation
    const { id: baseId } = useParams();

    console.log(baseId)
  const [anchorEl, setAnchorEl] = useState(null);

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const allJobClick = () =>{
    console.log("alljob")
  }

  const handleNavigation = (path) => {
    navigate(path); // Redirect to the specified path
    handleDropdownClose(); // Close all dropdowns
  };
  return (
    <div>
      {/* Recce Button */}
      <Button
        aria-controls={anchorEl ? "recce-dropdown" : undefined}
        aria-haspopup="true"
        onClick={handleDropdownOpen}
        endIcon={<ArrowDropDown />}
        variant="contained"
        color="primary"
      >
        Recce
      </Button>

      {/* Main Dropdown Menu */}
      <Menu
        id="recce-dropdown"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleDropdownClose}
      >
        {/* Approve Job */}
        <MenuItem 
        onClick={() => handleNavigation(`/user/AllCampaign/${baseId}/reccejobApprove`)}>
          Approve Job
        </MenuItem>

        {/* Job Table Trigger */}
        <MenuItem onClick={() => { 
            allJobClick(); 
          handleDropdownClose();
        }}>
          All Job
        </MenuItem>

       

       
      </Menu>
    </div>
  );
};

export default RecceDropdown;
